import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {Group} from '../../member/screens/groups/types';
import {unsubscribeToGroup} from './slice';

export const useUnsubscribeToGroup = () => {
  const dispatch = useDispatch();
  return useCallback(
    (group: Group) => {
      dispatch(unsubscribeToGroup(`group-${group.id}`));
    },
    [dispatch],
  );
};
